export default __webpack_public_path__ + "static/media/5.8492a6a9.png";